import { createSelector } from 'reselect'
import { ScannableCodesState } from './types'

export const selectScannableCodesState = (state: {
  scannableCodes: ScannableCodesState
}) => state.scannableCodes

export const selectFormDisabled = createSelector(
  [selectScannableCodesState],
  scannableCodesState => scannableCodesState.isFormDisabled
)

export const selectInstoreScanningEnabled = createSelector(
  [selectScannableCodesState],
  scannableCodesState => scannableCodesState.instoreScanningEnabled
)

export const selectIsFormSubmitting = createSelector(
  [selectScannableCodesState],
  scannableCodesState => scannableCodesState.isFormSubmitting
)

export const selectApiFormattedFormData = createSelector(
  [selectScannableCodesState],
  scannableCodesState => ({
    instore_scanning_enabled: scannableCodesState.instoreScanningEnabled,
  })
)
